export default __webpack_public_path__ + "static/media/img2.10afa7be.jpg";